import * as React from 'react'

import { useDispatch } from 'react-redux'

import { trackUserAddRemoveRecipe } from 'actions/loggingmanager'

import { useAddValidRecipeToBasket } from './useAddValidRecipeToBasket'

export type AddRecipeFn = ReturnType<typeof useAddRecipe>
export const useAddRecipe = () => {
  const addValidRecipeToBasket = useAddValidRecipeToBasket()
  const dispatch = useDispatch()

  return React.useCallback(
    (
      coreRecipeId: string,
      view?: string,
      recipeInfo?: {
        position: string
      },
      orderId?: string,
      isOrderRecipe?: boolean,
    ) => {
      addValidRecipeToBasket(coreRecipeId, view, recipeInfo, orderId, isOrderRecipe)
      dispatch(trackUserAddRemoveRecipe())
    },
    [dispatch, addValidRecipeToBasket],
  )
}
